
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }
        public get Pedido() { return this.ControladorBarras.PedidoSeleccionado; }

        public Archivo: File = null;
        public SeleccionarArchivo: boolean = false;

        async mounted()
        {
            if ( !this.Pedido )
            {
                return;
            }

            this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 400;
            this.Iniciar();
        }



        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {

        }


        async Abrir()
        {
            window.open( this.Pedido.DeclaracionBienDeUso );

        }

        async AgregarArchivo( x: File )
        {
            this.Archivo = x;
            if ( this.Archivo )
            {
                this.Guardar();
            }
        }

        public async Guardar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Guardar declaración jurada', `¿Está seguro de subir el archivo?` ) )
            {
                let e = await this.Pedido.SubirDeclararionIIBB( this.Archivo);
                if ( e )
                {
                    this.Cerrar();
                    this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
                }
                else
                {
                    this.$EventBus.Notificaciones.Error( 'Error al guardar el archivo' );
                }
            }
        }

        public async Eliminar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Eliminar declaración jurada', `¿Está seguro de eliminar el archivo? Si corresponde la factura tendrá retenciones de IIBB` ) )
            {
                let e = await this.Pedido.EliminarDeclararionIIBB();
                if ( e )
                {
                    this.Cerrar();
                    this.$EventBus.Notificaciones.Completado( 'Eliminado correctamente' );
                }
                else
                {
                    this.$EventBus.Notificaciones.Error( 'Error al eliminar el archivo' );
                }
            }
        }


        async Cerrar()
        {
            this.SubModo = 'pedidos';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
